// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/BusinessService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { BusinessDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { BusinessCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidDtoSchema, UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { BusinessDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { BusinessFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/BusinessService.proto.
 */
export const file_Services_BusinessService: GenFile = /*@__PURE__*/
  fileDesc("Ch5TZXJ2aWNlcy9CdXNpbmVzc1NlcnZpY2UucHJvdG8y+AcKD0J1c2luZXNzU2VydmljZRLkAQoLR2V0QnVzaW5lc3MSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGjQudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5CdXNpbmVzc0RldGFpbGVkRHRvIl+g2s0PAILT5JMCVFoeOgEqIhkvYXBpL2J1c2luZXNzL2dldEJ1c2luZXNzEjIvYXBpL2J1c2luZXNzL2dldEJ1c2luZXNzL3tpZC5oaWdoXzY0fS97aWQubG93XzY0fRKrAQoNR2V0QnVzaW5lc3NlcxIyLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZmlsdGVycy5CdXNpbmVzc0ZpbHRlcnNEdG8aOS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbGxlY3Rpb25zLkJ1c2luZXNzQ29sbGVjdGlvbkR0byIroNrNDwCC0+STAiA6ASoiGy9hcGkvYnVzaW5lc3MvZ2V0QnVzaW5lc3NlcxKfAQoOQ3JlYXRlQnVzaW5lc3MSKS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLkJ1c2luZXNzRHRvGjQudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5CdXNpbmVzc0RldGFpbGVkRHRvIiyg2s0PAILT5JMCIToBKiIcL2FwaS9idXNpbmVzcy9jcmVhdGVCdXNpbmVzcxLbAQoOVXBkYXRlQnVzaW5lc3MSKS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLkJ1c2luZXNzRHRvGjQudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5CdXNpbmVzc0RldGFpbGVkRHRvImig2s0PAILT5JMCXToBKlohOgEqIhwvYXBpL2J1c2luZXNzL3VwZGF0ZUJ1c2luZXNzGjUvYXBpL2J1c2luZXNzL3VwZGF0ZUJ1c2luZXNzL3tpZC5oaWdoXzY0fS97aWQubG93XzY0fRLPAQoORGVsZXRlQnVzaW5lc3MSJi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkRHRvGjQudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5CdXNpbmVzc0RldGFpbGVkRHRvIl+g2s0PAILT5JMCVFohOgEqIhwvYXBpL2J1c2luZXNzL2RlbGV0ZUJ1c2luZXNzKi8vYXBpL2J1c2luZXNzL2RlbGV0ZUJ1c2luZXNzL3toaWdoXzY0fS97bG93XzY0fUIkqgIhTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLlNlcnZpY2VzYgZwcm90bzM", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * CRUD operations for businesses.
 *
 * @generated from service BusinessService
 */
export const BusinessService: GenService<{
  /**
   * Fetch a business specified by its id.
   *
   * @generated from rpc BusinessService.GetBusiness
   */
  getBusiness: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof BusinessDetailedDtoSchema;
  },
  /**
   * Fetch businesses according to filters.
   *
   * @generated from rpc BusinessService.GetBusinesses
   */
  getBusinesses: {
    methodKind: "unary";
    input: typeof BusinessFiltersDtoSchema;
    output: typeof BusinessCollectionDtoSchema;
  },
  /**
   * Create a new business.
   *
   * @generated from rpc BusinessService.CreateBusiness
   */
  createBusiness: {
    methodKind: "unary";
    input: typeof BusinessDtoSchema;
    output: typeof BusinessDetailedDtoSchema;
  },
  /**
   * Modify business properties.
   *
   * @generated from rpc BusinessService.UpdateBusiness
   */
  updateBusiness: {
    methodKind: "unary";
    input: typeof BusinessDtoSchema;
    output: typeof BusinessDetailedDtoSchema;
  },
  /**
   * Delete the business with the given id.
   *
   * @generated from rpc BusinessService.DeleteBusiness
   */
  deleteBusiness: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof BusinessDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_BusinessService, 0);

